module.exports = __webpack_public_path__ + "static/img/logo.659fe080.jpg";